import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgAddPolygon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M18 0a2 2 0 011.001 3.732v8.536a2 2 0 11-2.733 2.733H7.732a2 2 0 11-1.245-2.941l9.573-9.573A2 2 0 0118 0zm-1 4.375L8.375 13h7.893a2.01 2.01 0 01.732-.732zM8 0v2h2v2H8v2H6V3.999L4 4V2l2-.001V0z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('AddPolygon')(SvgAddPolygon);
